/* Manteau Noir V59.117 — restrained newsletter slide-in */
(function () {
  'use strict';

  var root = document.querySelector('[data-mn-newsletter-slide-in]');
  if (!root) return;

  var closeButton = root.querySelector('[data-mn-newsletter-slide-in-close]');
  var form = root.querySelector('form');
  var success = root.querySelector('[data-mn-newsletter-slide-in-success]');
  var error = root.querySelector('[data-mn-newsletter-slide-in-error]');
  var now = Date.now();
  var DAY = 24 * 60 * 60 * 1000;
  var DISMISS_FOR = 14 * DAY;
  var SUBSCRIBED_FOR = 365 * DAY;

  function readNumber(key) {
    try {
      var value = parseInt(localStorage.getItem(key), 10);
      return isNaN(value) ? 0 : value;
    } catch (e) {
      return 0;
    }
  }

  function writeNumber(key, value) {
    try { localStorage.setItem(key, String(value)); } catch (e) {}
  }

  function readSession(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function writeSession(key, value) {
    try { sessionStorage.setItem(key, String(value)); } catch (e) {}
  }

  function show() {
    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    writeSession('mnNewsletterSlideInShown', '1');
  }

  function hide() {
    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
  }

  if (success) {
    writeNumber('mnNewsletterSlideInSubscribedUntil', now + SUBSCRIBED_FOR);
    show();
    window.setTimeout(hide, 6500);
    return;
  }

  if (error) {
    show();
    return;
  }

  if (readNumber('mnNewsletterSlideInSubscribedUntil') > now) return;
  if (readNumber('mnNewsletterSlideInDismissedUntil') > now) return;
  if (readSession('mnNewsletterSlideInShown')) return;

  var pageCount = parseInt(readSession('mnNewsletterPageCount'), 10);
  if (isNaN(pageCount) || pageCount < 0) pageCount = 0;
  pageCount += 1;
  writeSession('mnNewsletterPageCount', pageCount);

  var delay = pageCount >= 2 ? 12000 : 40000;
  window.setTimeout(show, delay);

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      writeNumber('mnNewsletterSlideInDismissedUntil', Date.now() + DISMISS_FOR);
      hide();
    });
  }

  if (form) {
    form.addEventListener('submit', function () {
      writeSession('mnNewsletterSlideInShown', '1');
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-visible')) {
      writeNumber('mnNewsletterSlideInDismissedUntil', Date.now() + DISMISS_FOR);
      hide();
    }
  });
})();
